import { render, staticRenderFns } from "./chi-siamo.vue?vue&type=template&id=00e61316&scoped=true&"
import script from "./chi-siamo.vue?vue&type=script&lang=js&"
export * from "./chi-siamo.vue?vue&type=script&lang=js&"
import style0 from "./chi-siamo.vue?vue&type=style&index=0&id=00e61316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e61316",
  null
  
)

export default component.exports